import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SubscribeButton } from './SubscribeButton';
import { useScrolledPast } from '../hooks/useScrolledPast';
import { channel } from '../data/channel';
export function FloatingSubscribe() {
  const past = useScrolledPast(900);
  const [dismissed, setDismissed] = useState(false);
  const show = past && !dismissed;
  return <AnimatePresence data-id="element-29" data-mp="1mp7m1tq20gw6">
      {show && <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-3 bottom-3 z-40 flex items-center gap-3 rounded-full border border-line bg-raised py-2 pl-5 pr-2 sm:inset-x-auto sm:right-6 sm:bottom-6" role="complementary" aria-label="Підписка на канал" data-id="element-30" data-mp="1hs7pc9f3gqhq">
          <p className="min-w-0 truncate text-sm font-semibold text-paper" data-id="element-31" data-mp="3sm3jugvu7ei3">
            Подобається? Будь з {channel.name}
          </p>
          <SubscribeButton data-id="element-32" data-mp="1j4pwx84v1e6d" />
          <button onClick={() => setDismissed(true)} aria-label="Сховати" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-muted transition-colors duration-150 hover:bg-line hover:text-paper" data-id="element-33" data-mp="1j60zj4mkkfvw">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="1www3q3m4i8t5" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}